// fondoMedia.js — foco teal y grano de película de las tarjetas de "foto" del
// estilo E (landing v4, pantallas de acceso, onboarding).
//
// Antes vivían dentro de views/authentication/AuthShell.js. Se extrajeron al
// sumar el panel de animación del onboarding (#1525 T7, R19) para que el acceso
// y el onboarding pinten exactamente el mismo fondo y no diverjan con el tiempo.
// Todo color sale de tokens de theme.js (`--media-spot-rgb`, `--color-primary-rgb`);
// este archivo no tiene ningún color literal.

// Grano de película (mismo filtro que la landing E). El SVG no lleva colores:
// solo una matriz que deja blanco al 5% sobre `mix-blend-mode: overlay`.
export const GRANO =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 .05 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

export const foco = (x, y) =>
  `radial-gradient(circle at ${x} ${y}, rgba(var(--media-spot-rgb),0.9) 0, rgba(var(--media-spot-rgb),0.7) 7%, ` +
  "rgba(var(--color-primary-rgb),0.75) 14%, rgba(var(--color-primary-rgb),0.4) 22%, " +
  "rgba(var(--color-primary-rgb),0.15) 31%, rgba(var(--color-primary-rgb),0.05) 39%, transparent 46%)";
